<template>
  <Fragment>
    <v-btn class="pl-2" fab outlined height="20" width="20" :loading="loadingStart">
      <v-icon x-small class="mr-2" :disabled="disabledStart" @click="start()">mdi-play</v-icon>
    </v-btn>
    <v-btn class="pl-2 ml-3" fab outlined height="20" width="20" :loading="loadingStop">
      <v-icon x-small class="mr-2" :disabled="disabledStop" @click="stop()">mdi-stop</v-icon>
    </v-btn>
  </Fragment>
</template>

<script>
import { api } from '@/api/common/instances';
import { Fragment } from 'vue-fragment';
import bus from '@/utils/bus';
import { pascalCase } from 'change-case';

export default {
  components: { Fragment },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loadingStart: false,
    loadingStop: false,
  }),
  computed: {
    disabledStart() {
      // group 내의 개별 수집기 상태가 전부 활성화되어 있으면 -> 시작 버튼 비활성화
      return (this.item.children || []).every(child => child.collecting == true);
    },
    disabledStop() {
      // group 내의 개별 수집기 상태가 전부 비활성화되어 있으면 -> 중지 버튼 비활성화
      return (this.item.children || []).every(child => child.collecting != true);
    },
  },
  methods: {
    async start() {
      // 전부 비활성 상태이면, 수집기를 시작한다.
      if ((this.item.children || []).every(child => child.collecting != true)) {
        const response = await this.collector('start');
        if (response.status == 200) bus.$emit('activated-collector', this.item);
      }
      // 일부가 비활성 상태이면, 개별 수집(비활성 상태인 것만)을 시작한다.
      else {
        this.item.children.forEach(async item => {
          const response = await this.collect('start');
          if (response.status == 200 && item.collecting != true) bus.$emit('activated-collect', item);
        });
      }
    },
    async stop() {
      // 전부 활성 상태이면, 수집기를 정지한다.
      if ((this.item.children || []).every(child => child.collecting == true)) {
        const response = await this.collector('stop');
        if (response.status == 200) bus.$emit('deactivated-collector', this.item);
      }
      // 일부가 활성 상태이면, 개별 수집(활성 상태인 것만)을 정지한다.
      else {
        this.item.children.forEach(async item => {
          const response = await this.collect('start');
          if (response.status == 200 && item.collecting == true) bus.$emit('deactivated-collect', item);
        });
      }
    },
    async collector(type) {
      const loading = `loading${pascalCase(type)}`;
      this[loading] = true;
      const response = await api.post(`/preference/collectors/${this.item.id}/${type}`);
      this[loading] = false;
      return response;
    },
    async collect(item, type) {
      const loading = `loading${pascalCase(type)}`;
      this[loading] = true;
      const response = await api.post(`/preference/collectors/${item.systemId}/${item.stackType}/${type}`);
      this[loading] = false;
      return response;
    },
  },
};
</script>

<style></style>
